// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"HK-z","carouselContainer":"IK-z"};